export const DISCARD_SURVEY_CHANGES_CONFIRMATION = {
  TITLE: 'Discard Changes',
  MESSAGE:
    'Are you sure you want to exit?<br><br>If you want to save this project, you can use the Save Tool on the bottom left of this screen.',
  CONTINUE_LABEL: 'No, continue working',
  LEAVE_WITHOUT_SAVING_LABEL: 'Yes, leave without saving',
  LEAVE_AND_SAVE_LABEL: 'Yes, leave and save',
} as const;
